
import { mapActions, mapGetters } from 'vuex'
import setCatalogFiltersQueryParams from '../../Catalog/CatalogFilters/mixins/catalog-filters-query-params'
import { getDistributorShippingTermsDescr } from '../../../helpers/distributor'
import ConnectDistributorFailedTitle from './ConnectDistributorFailedTitle'
import iconPerson from '~/ZenOne-StoryBook/assets/icon/personCircle.svg'
import dialogFormConnectDistributors from '~/components/dialog/dialog-form-connect-distributors'
import dialogShippingTerms from '~/components/dialog/dialog-shipping-terms'
import dialogUnlinkDistributor from '~/components/dialog/dialog-unlink-distributor'
import dialogConnectDistributorsLoginSuccessfully
  from '~/components/dialog/dialog-connect-distributors-login-successfully'
import iconSettings from '~/components/img/icon-settings.svg'
import iconSettingsDisabled from '~/components/img/icon-settings-disabled.svg'
import shrink from '~/ZenOne-StoryBook/mixins/shrink.js'
import localStorage from '~/ZenOne-StoryBook/mixins/localStorage.js'
import iconI from '~/components/img/icon-i.svg'
import {
  STATUS_ACTIVE,
  STATUS_PENDING,
  STATUS_FAILED
} from '~/helpers/connect-distributors'
import { getBaseUrl } from '~/config/api'

export default {
  name: 'DistributorConnectCard',
  components: {
    ConnectDistributorFailedTitle,
    dialogFormConnectDistributors,
    dialogConnectDistributorsLoginSuccessfully,
    dialogShippingTerms,
    dialogUnlinkDistributor
  },
  mixins: [shrink, localStorage, setCatalogFiltersQueryParams],
  props: {
    item: {
      type: Object,
      default: null
    },
    slim: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      iconPerson,
      iconI,
      iconSettings,
      iconSettingsDisabled,
      getDistributorShippingTermsDescr,
      openDialogFormConnectDistributors: false,
      openDialogUnlinkDistributor: false,
      openDialogShippingTerms: false,
      showWhatsNext: false
    }
  },
  computed: {
    ...mapGetters({
      user: `user/user`
    }),
    distributorName() {
      return this.item?.name ?? ''
    },
    distributorLogoSrc() {
      return this.item?.logoDistributor ?? ''
    },
    isPreferred() {
      return this.item?.preferred ?? false
    },
    status() {
      return this.item?.status ?? null
    },
    hasStatus() {
      return !!this.status
    },
    note() {
      return this.item?.note ?? ''
    },
    isPending() {
      return this.status === STATUS_PENDING
    },
    isActive() {
      return this.status === STATUS_ACTIVE
    },
    isFailed() {
      return this.status === STATUS_FAILED
    },
    canManageLocations() {
      return !!this.user.permissions.canManageLocations
    }
  },
  watch: {},
  methods: {
    ...mapActions('catalog', ['ClearFilters']),
    onCloseDialogUnlinkDistributor() {
      this.openDialogUnlinkDistributor = false
      this.$emit('onRefreshDistributors')
    },
    onOpenDialogUnlinkDistributor() {
      this.openDialogUnlinkDistributor = true
    },
    onRefreshDistributors() {
      this.$emit('onRefreshDistributors')
    },
    onOpenDialogShippingTerms() {
      this.openDialogShippingTerms = true
    },
    async viewDistributorCatalogBtnClickHandler() {
      this.ClearFilters()
      this.$store.commit('catalog/SET_FILTER_DISTRIBUTOR', {
        value: [parseInt(this.item.id)]
      })
      await this.$router.push('/')
    },
    onConnect() {
      this.openDialogFormConnectDistributors = true
    },
    async onConnectDistributors(v) {
      try {
        await this.$axios.post(`${getBaseUrl()}/api/v2/distributor/${this.item.id}/connect`, v)
      } catch (e) {
        console.error(e)
      }

      this.openDialogFormConnectDistributors = false

      this.$emit('onRefreshDistributors')
    }
  }
}
